import { render, staticRenderFns } from "./applyReturn.vue?vue&type=template&id=97e4c240&scoped=true"
import script from "./applyReturn.vue?vue&type=script&lang=js"
export * from "./applyReturn.vue?vue&type=script&lang=js"
import style0 from "./applyReturn.vue?vue&type=style&index=0&id=97e4c240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e4c240",
  null
  
)

export default component.exports